const CoinsTable = () => {
    return (
        <div className='mb-8 border-4 border-[#393939] bg-[#262626] sm:mx-4 md:mx-11'>
            <div className='flex w-full justify-around  bg-[#3f3939] py-2 font-serif text-sm text-white'>
                <span>Logo</span>
                <span>Token Name</span>
                <span>Address</span>
                <span>Confirms</span>
                <span>Status</span>
            </div>
        </div>
    );
};

export default CoinsTable;
